import { createFileRoute } from '@tanstack/react-router';

import { Page } from '@common/ui/Page';

import { InviteCandidate } from '@widgets/invite/InviteCandidate';

export const Route = createFileRoute('/invite/candidate')({
  component: Component,
});

export default function Component() {
  return (
    <Page style={{ padding: 0, paddingBottom: 8 }}>
      <InviteCandidate />
    </Page>
  );
}
